import { connect } from 'react-redux';
import { compose } from 'redux';
import { withContext, getContext, withHandlers } from 'recompose'
import PropTypes from 'prop-types'

import { updateAnswersText } from '../actions'
import Levels from '../components/Levels'

const withStore = compose(
    withContext({ store: PropTypes.object }, () => {}),
    getContext({ store: PropTypes.object }),
  )

function mapStateToProps(state) {

    const { selectedAssessment, selectedActivity, errorMessage } = state

    return {
      selectedAssessment,
      selectedActivity,
      errorMessage

    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        handleTextOnChange: (content,delta, source, editor, levelId) => {
            dispatch(updateAnswersText(content, levelId,ownProps.store))
          },
    }
}


export default compose(
    withStore,
    withHandlers({
        findText: props => (answers,activityId,levelId) => {
        const found = answers.find(
            answer =>  answer.activityId === activityId && answer.levelId === levelId)
            if (found) return found.text 
            return ''
        }
    }),
    connect(
        mapStateToProps,
        mapDispatchToProps)
)(Levels)


// WEBPACK FOOTER //
// ./src/levels/containers/Levels.js